import {GridType} from "../../types";
import {BASE_ITEM_ANIMATION} from "../../ToolsPanel/base_items/BaseItem";
import {dataStorage} from "../StorageService";

export async function clearColumnsAsync(
    columns: number[],
    copyGridData: GridType,
    setGridData: (data: GridType) => void,
    playSoundBomb: () => void,
) {
    const promises = [];

    for (const col of columns) {
        const promise = new Promise<any>(async resolve => {
            for (let i = 0; i < copyGridData.length; i++) {
                await new Promise<any>((resolve) => {
                    setTimeout(() => {
                        if (copyGridData[i][col].item) {
                            copyGridData[i][col].item!.isDisappearance = true;
                        }
                        setGridData([...copyGridData]);
                        resolve(copyGridData);
                        setTimeout(async () => {
                            await new Promise<any>(async (resolve) => {
                                if (copyGridData[i][col].item?.typeOfItem === 'BOMB' && dataStorage.isBombMode) {
                                    playSoundBomb();
                                    await clearBombRadius(copyGridData, i, col, setGridData);
                                }
                                copyGridData[i][col].item = undefined;
                                setGridData([...copyGridData]);
                                resolve(copyGridData);
                            })
                        }, BASE_ITEM_ANIMATION)
                    }, 25 + ((i + 1) * 2));
                });
            }
            resolve(copyGridData);
        })
        promises.push(promise);
    }

    return await Promise.all(promises);
}

export async function clearRowsAsync(
    rows: number[],
    copyGridData: GridType,
    setGridData: (data: GridType) => void,
    playSoundBomb: () => void,
) {
    const promises = [];

    for (const row of rows) {
        const promise = new Promise<any>(async resolve => {
            for (let i = 0; i < copyGridData.length; i++) {
                await new Promise<any>((resolve) => {
                    setTimeout(() => {
                        if (copyGridData[row][i].item) {
                            copyGridData[row][i].item!.isDisappearance = true;
                        }
                        setGridData([...copyGridData]);
                        resolve(copyGridData);
                        setTimeout(async () => {
                            await new Promise<any>(async (resolve) => {
                                if (copyGridData[row][i].item?.typeOfItem === 'BOMB' && dataStorage.isBombMode) {
                                    playSoundBomb();
                                    await clearBombRadius(copyGridData, row, i, setGridData);
                                }
                                copyGridData[row][i].item = undefined;
                                setGridData([...copyGridData]);
                                resolve(copyGridData);
                            })
                        }, BASE_ITEM_ANIMATION)
                    }, 25 + ((i + 1) * 2));
                });
            }
            resolve(copyGridData);
        })
        promises.push(promise);
    }

    return await Promise.all(promises);
}

//TODO сделать валидный score для удаляемых элементов при взрыве бомбы
async function clearBombRadius(copyGridData: GridType, row: number, col: number, setGridData: (data: GridType) => void) {
    const radius = 1;
    const cellsToClear: { row: number; col: number; }[] = [];

    for (let i = row - radius; i <= row + radius; i++) {
        for (let j = col - radius; j <= col + radius; j++) {
            if (i >= 0 && i < copyGridData.length && j >= 0 && j < copyGridData[0].length) {
                cellsToClear.push({row: i, col: j});
            }
        }
    }

    // Устанавливаем isDisappearance для всех элементов в радиусе
    for (const cell of cellsToClear) {
        const item = copyGridData[cell.row][cell.col].item;
        if (item) {
            item.isDisappearance = true;
        }
    }
    setGridData([...copyGridData]);

    // Удаляем элементы в радиусе через BASE_ITEM_ANIMATION
    setTimeout(async () => {
        for (const cell of cellsToClear) {
            const item = copyGridData[cell.row][cell.col].item;
            if (item?.typeOfItem === 'BOMB') {
                await clearBombRadius(copyGridData, cell.row, cell.col, setGridData); // Рекурсивно взрываем бомбы
            } else {
                copyGridData[cell.row][cell.col].item = undefined;
            }
        }
        setGridData([...copyGridData]);
    }, BASE_ITEM_ANIMATION);

    // Удаляем саму бомбу
    setTimeout(() => {
        copyGridData[row][col].item = undefined;
        setGridData([...copyGridData]);
    }, 700);
}